export default "__VITE_ASSET__B8N$73Zb__"